<p-toast position="top-right"></p-toast>
<div class="flex flex-row members-res">
    <div class="flex">
        <div class="card card-w-title p-dataView-tecfolk-fix" [ngClass]="{ 'loading': loading }">
            <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                    animationDuration=".5s"></p-progressSpinner></div>

            <p-dataView #ev [value]="assets" (onPage)="onPageChange($event)" paginatorPosition="both"
                [paginator]="true" [rows]="40" [loading]="loading" [first]="first">
                <p-header>
                    <div class="p-helper-clearfix">
                        <div style="display: flex; flex-direction: column;" >
                            <div style="display: flex; flex-wrap: nowrap; gap: 10px;" class="flex flex-row gap-3 MemberSearchField">
                                <div class="flex-1 flex">

                                    <input pinputtext="" id="nameSearch" #nameSearch (keyup)="searchLocal(asset.name, 'name')"
                                        [placeholder]='setLabel("searchNamePlaceholderLabel")' type="text" autocomplete="off" name="name"
                                        [(ngModel)]="asset.name" class="p-inputtext p-corner-all p-state-default p-widget">
                                </div>
                                <div class=" flex-1 flex">
                                    <input pinputtext="" id="tagSearch" [placeholder]='setLabel("searchSerialNumberPlaceholderLabel")' type="number" name="tag"
                                        (keyup)="searchLocal(asset.serialNumber, 'serialNumber')" [(ngModel)]="asset.serialNumber" autocomplete="off"
                                        class="p-inputtext p-corner-all p-state-default p-widget">
                                </div>
                            </div>
                            <div style="display: flex; padding: 0;" class="search-Button-Arabic">
                                <div class="flex-1 MemberToolbarButton">
                                    <button (click)="clear()"
                                        class="p-button-warn p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                            class="fa fa-eraser"></i>&nbsp;{{setLabel("clearLabel")}}
                                    </button>

                                    <button  routerLink="/add-assets"
                                        class="addNewArabic p-button-primary p-button p-widget p-state-default p-corner-all p-button-text-only">
                                        <i class="fa fa-plus"></i>&nbsp;{{setLabel("addNewLabel")}}<span
                                            style=" font-family: none; font-size: small; color: limegreen;">(F2)</span>
                                    </button>

                                    <button (click)="openExportData()"
                                        style="background-color: #1ab352;"
                                        class=" p-button-primary p-button p-widget p-state-default p-corner-all p-button-text-only"
                                        *ngIf='this.role.name === "Super Admin" || currentUserData.name == "Umair Masood" || currentUserData.name == "Wajahat Khan"'><i
                                            class="fa fa-file-excel-o"></i>&nbsp;{{setLabel("exportLabel")}}
                                    </button>

                                    <button (click)="dialogVisibilityImportDialogue = 'true'"
                                    style="background-color:#5097b7;"
                                    class="p-button-primary p-button p-widget p-state-default p-corner-all p-button-text-only"
                                    *ngIf='this.role.name === "Super Admin"'><i
                                    class="fa fa-file-excel-o"></i>&nbsp;{{setLabel("importLabel")}}
                                </button>
                              </div>
                            </div>
                          </div>
                      </div>
                  </p-header>
                  <ng-template let-asset pTemplate="gridItem">
                    <div style="padding:.5em; cursor: pointer; "
                        class="p-g-12 p-md-6 p-lg-4 p-xl-3 user-card-grid-tecfolk-fix"
                       >
                        <p-panel [style]="{'text-align':'center'}">
                            <p-header>
                                <div class="user-card-grid-p-header-tecfolk-fix">

                                    <div class="user-name-tag-number">

                                    {{asset.name}}-{{member.serialNumber}}
                                    </div>

                                </div>
                            </p-header>
                            <div *ngIf='this.currentUserData.role === "Super Admin" || this.currentUserData.role === "Admin"|| this.currentUserData.role === "Trainer"'
                                class="car-detail" style="opacity: 1;display: flex;justify-content: center;align-items: center; height: 170px;"
                                >
                                <img style="max-width: 170px;max-height: 170px;" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
                                    [src]=" asset.profile
                                                            ? config.Server + config.assetImagePath + 'thumbs/' + asset.profile
                                                            : 'assets/layout/images/avatarBoyImage.png'" (click)="viewAsset(asset)" />
                            </div>

                            <div *ngIf='this.currentUserData.role === "Operator" && this.currentUserData.gender === "F" ' class="car-detail"
                                style="opacity: 1;display: flex;justify-content: center;align-items: center; height: 170px;"
                                >
                                <img style="max-width: 170px;max-height: 170px;" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
                                    [src]=" asset.profile
                                                        ? config.Server + config.assetImagePath + 'thumbs/' + asset.profile
                                                        : 'assets/layout/images/avatarBoyImage.png'"
                                                         (click)="viewAsset(asset)" />
                            </div>
                            <div class="car-detail dueDateStyleFlex" (click)="viewAsset(asset)">
                                <b *ngIf='this.currentUserData.role === "Super Admin" || this.currentUserData.role === "Admin" || this.currentUserData.role === "Trainer" '
                                    [ngStyle]="{'color':asset.contactDetail.contact ? '#212121' : '#939393'}"> {{asset.serialNumber
                                    ? asset.serialNumber : 'No Number' }}</b>

                                <b *ngIf='this.currentUserData.role === "Operator" && this.currentUserData.gender === "F" '>
                                  {{asset.serialNumber
                                    ? asset.serialNumber : 'No Number' }}</b>

                                <b class="custom-blur-input" *ngIf='this.currentUserData.role === "Operator" && this.currentUserData.gender === "M" '>
                                    {{ asset.serialNumber }}
                                 </b>
                            </div>

                            <hr class="p-widget-content" style="border-top:0">
                            <div style="display: flex;justify-content: space-evenly; gap: 1em;"
                                class="user-card-grid-toolbar-tecfolk-fix">


                                <button pButton type="button" [pTooltip]='setLabel("DeactivateLabel")' tooltipPosition="top"
                                    class="p-button-danger p-button borderRadiousXs" icon="fa fa-times"
                                    (click)="deleteMember(asset)"></button>

                                <button pButton type="button" [pTooltip]='setLabel("editTooltipLabel")' tooltipPosition="top"
                                    icon="fa fa-pencil-square-o" (click)="viewAsset(asset)"
                                    class=" borderRadiousXs"></button>

                                <button pButton type="button" pTooltip='Add Member' tooltipPosition="top"
                                    class="p-button-primary p-button borderRadiousXs" icon="fa fa-money"
                                    style="background: #1ab394" (click)="payFee(asset._id)"></button>

                            </div>
                        </p-panel>
                    </div>
                </ng-template>
                <ng-template let-asset pTemplate="listItem">
                  <div class="listItemNewStyle ">
                      <div class="imgListItem" style="text-align:center; ">
                          <img style="height: 250px;
                          width: 250px;" [src]="asset.profile
                              ? config.Server + config.assetImagePath + 'thumbs/' + asset.profile
                              : 'assets/layout/images/avatarBoyImage.png'"
                              (click)="viewAsset(asset)"
                              onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" />
                      </div>
                      <div class="infoListItem">
                          <div class="infoListItemMain">
                              <div class="infoListItemMainDataType even">{{setLabel("nameLabel")}}</div>
                              <div class="infoListItemMainDataType even">
                                  <b (click)="viewAsset(asset)">{{asset.name}}</b>
                              </div>
                              <div class="infoListItemMainDataType odd">{{setLabel("categoryLabel")}}</div>
                              <div class="infoListItemMainDataType odd">
                                  <b (click)="viewAsset(asset)">{{asset.category}}</b>
                              </div>
                              <div class="infoListItemMainDataType even">{{setLabel("costLabel")}}</div>
                              <div class="infoListItemMainDataType even">
                                  <b (click)="viewAsset(asset)">{{asset.cost}}</b>
                              </div>
                              <div class="infoListItemMainDataType odd">{{setLabel("statusLabel")}}</div>
                              <div class="infoListItemMainDataType odd">
                                  <b (click)="viewAsset(asset)">{{asset.status}}</b>
                              </div>
                          </div>
                      </div>
                      <div class="btnListItem">
                          <button pButton type="button" [pTooltip]='setLabel("deactivateAssetTooltipLabel")'
                              class="p-button-danger p-button btnListItemBtn" icon="fa fa-times"
                              (click)="deleteMember(asset)"><span class="span">{{setLabel("deactivateLabel")}}</span></button>
                          <button style="width: max-content;" pButton type="button" [pTooltip]='setLabel("editAssetDetailsTooltipLabel")'
                              icon="fa fa-pencil-square-o" (click)="viewAsset(asset)" class="btnListItemBtn"><span
                                  class="span">{{setLabel("editAssetLabel")}}</span> </button>
                      </div>
                  </div>
              </ng-template>
          </p-dataView>
      </div>
  </div>
</div>